import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkDeleteSmokerRateOverrideRules } from '../../../api/plan-smoker-rate-override-rules-api'
import type { BulkDeleteSmokerRateOverrideRulesRequestDto } from '../../../api/dto/plan-smoker-rate-override-rules.dto'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'

export function useBulkDeleteSmokerRateOverrideRules() {
  const queryClient = useQueryClient()

  return useMutation<
    void,
    unknown,
    BulkDeleteSmokerRateOverrideRulesRequestDto
  >({
    mutationFn: (body) => bulkDeleteSmokerRateOverrideRules(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
